import { SubMenu } from 'rc-menu';

export default SubMenu;
